module Meevo.Plugins.MembershipTypes {
    "use strict";

    export enum MembershipTypeUngrandfatherEnum {
        BenefitTemplate,
        RenewalPricing,
        Both
    }

    interface IGrandfatheredMemberships {
        benefitTemplates: number;
        renewalPricing: number;
        total: number;
    }

    interface IScheduledUngrandfathering {
        type: MembershipTypeUngrandfatherEnum;
        date: Date;
        label: string;
    }

    export class UngrandfatherSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MembershipType> {
        public disableCrud: boolean = true;
        public minDateForScheduleUngrandfather: Date;
        public setDateUngrandfather: Date;
        public isUngrandfatherNotAllow: boolean;
        public isUngrandfatherExist: boolean;
        public membershipTypeUngrandfatherEnum = MembershipTypeUngrandfatherEnum;
        public ungrandfatherOption: MembershipTypeUngrandfatherEnum = MembershipTypeUngrandfatherEnum.BenefitTemplate;
        public grandfatheredMemberships: IGrandfatheredMemberships;
        public scheduledUngrandfathering: IScheduledUngrandfathering;
        public priceGroupQueueId: Guid | string;
        
        constructor(protected params: Meevo.Model.ISectionParamsExtendedDataService) {

            super(params.sectionId,
                  params.displayNameContentKey,
                  params.template, 
                  params.isPrimarySection, 
                  params.handlesOwnCrud,
                  params.baseEndpoint, 
                  params.sectionEndpoint,
                  params.loggingService,
                  params.dataService,
                  params.identityService,
                  params.noun,
                  null,
                  params.sectionSecurityKey);

            this.minDateForScheduleUngrandfather = new Date(new Date().getTime() + 86400000); // set tomorrow
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = <Model.MembershipType>data;

                this.getGrandfatheredMembership();
            });
        }

        // Tab open
        activate(): void {
            this.getGrandfatheredMembership();

            super.activate();
        }

        // Get counts
        getGrandfatheredMembership(): void {
            this.isUngrandfatherNotAllow = false;
            this.isUngrandfatherExist = false;

            this.loadingInProgress = true;

            this.dataService.customMethodData(`/api/PriceManagement/${this.model.id}/GrandfatheredMembership/Count`, 'GET', null)
                .then((res) => {
                    this.priceGroupQueueId = res.data.priceGroupQueueId || null;

                    this.grandfatheredMemberships = {
                        benefitTemplates: res.data.benefitTemplatesCount || 0,
                        renewalPricing: res.data.renewalPricingCount || 0,
                        total: res.data.totalCount || 0
                    }

                    if (res.data.isGrandfathering) {
                        this.params.modalService.alert('WARNING_MSG_UNGRANDFATHER_SCHEDULED_LOCATION_TRANSFER');
                        this.isUngrandfatherNotAllow = true;
                    } else {
                        if (res.data.scheduledDate) {
                            this.isUngrandfatherExist = true;
                            this.isUngrandfatherNotAllow = true;

                            let scheduledType = this.compileScheduledType(res.data);

                            this.scheduledUngrandfathering = {
                                type: scheduledType,
                                date: res.data.scheduledDate,
                                label: this.calculateUngrandfatheringLabel(scheduledType)
                            }
                        }
                    }

                    this.loadingInProgress = false;
                });
        }

        // Find right label for ungrandfathering
        calculateUngrandfatheringLabel(type: MembershipTypeUngrandfatherEnum): string {
            switch (type) {
                case MembershipTypeUngrandfatherEnum.BenefitTemplate:
                    return 'LABEL_UNGRANDFATHER_BENEFIT_TEMPLATES';
                case MembershipTypeUngrandfatherEnum.RenewalPricing:
                    return 'LABEL_UNGRANDFATHER_RENEWAL_PRICING';
                case MembershipTypeUngrandfatherEnum.Both:
                    return 'LABEL_UNGRANDFATHER_BOTH_TEMPLATES_AND_PRICING';
                default:
                    return '';
            }
        }

        // Compile right label for view right option on the screen
        compileScheduledType(data): any {
            if (!data.benefitTemplatePricing && data.membershipPricing) {
                return MembershipTypeUngrandfatherEnum.BenefitTemplate;
            } else if (data.benefitTemplatePricing && !data.membershipPricing) {
                return MembershipTypeUngrandfatherEnum.RenewalPricing;
            } else if (!data.benefitTemplatePricing && !data.membershipPricing) {
                if (data.benefitTemplatePricing === undefined) {
                    return MembershipTypeUngrandfatherEnum.RenewalPricing;
                } else if (data.membershipPricing === undefined) {
                    return MembershipTypeUngrandfatherEnum.BenefitTemplate;
                } else {
                    return MembershipTypeUngrandfatherEnum.Both;
                }
            }
        }

        // Check date is available for ungrandfathering
        checkDateIsAvailable(): angular.IPromise<any> {
            let criteria = {
                scheduleDate: this.setDateUngrandfather
            }

            this.loadingInProgress = true;

            return this.dataService.customMethodData(`/api/MarketPricing/LocationTransfer/Count`, 'POST', criteria).then((res) => {
                if (res.data.count > 250) {
                    this.params.modalService.alert('WARNING_UNGRANDFATHER_SCHEDULED_DAY');
                    this.setDateUngrandfather = null;
                }

                this.priceGroupQueueId = res.data.locationTransfer ? res.data.locationTransfer.priceGroupQueueId : null;

                this.loadingInProgress = false;
            });
        }

        // Schedule Ungrandfathering
        scheduleUngranfather(): void {
            let optionForScheduleUngrandfather;

            switch (this.ungrandfatherOption) {
                case MembershipTypeUngrandfatherEnum.BenefitTemplate:
                    optionForScheduleUngrandfather = 'Benefit Template';
                    break;
                case MembershipTypeUngrandfatherEnum.RenewalPricing:
                    optionForScheduleUngrandfather = 'Renewal Fee';
                    break;
                default:
                    optionForScheduleUngrandfather = 'Renewal Fee and Benefit Template';
                    break;
            }

            let messageForScheduleUngrandfather = this.params.$translate.instant('MESSAGE_SCHEDULE_UNGRANDFATHERING', {
                option: optionForScheduleUngrandfather
            });

            this.params.modalService.confirm(messageForScheduleUngrandfather).then((res) => {
                if (res) {
                    let count = 0,
                        benefitTemplatePricing = null,
                        membershipPricing = null,
                        criteria;

                    switch (this.ungrandfatherOption) {
                        case MembershipTypeUngrandfatherEnum.BenefitTemplate:
                            count = this.grandfatheredMemberships.benefitTemplates;
                            benefitTemplatePricing = false;
                            break;
                        case MembershipTypeUngrandfatherEnum.RenewalPricing:
                            count = this.grandfatheredMemberships.renewalPricing;
                            membershipPricing = false;
                            break;
                        case MembershipTypeUngrandfatherEnum.Both:
                            count = this.grandfatheredMemberships.total;
                            benefitTemplatePricing = false;
                            membershipPricing = false;
                            break;
                    }


                    criteria = {
                        membershipTypeId: this.model.id,
                        scheduleDate: this.setDateUngrandfather,
                        benefitTemplatePricing: benefitTemplatePricing,
                        membershipPricing: membershipPricing,
                        membershipsCount: count,
                        priceGroupQueueId: this.priceGroupQueueId
                    }

                    this.loadingInProgress = true;

                    this.dataService.customMethodData('api/MarketPricing/Ungrandfather', 'PUT', criteria).then((res) => {
                        this.isUngrandfatherNotAllow = true;
                        this.isUngrandfatherExist = true;

                        // show added ungrandfathering
                        this.scheduledUngrandfathering = {
                            type: this.ungrandfatherOption,
                            date: this.setDateUngrandfather,
                            label: this.calculateUngrandfatheringLabel(this.ungrandfatherOption)
                        }

                        this.priceGroupQueueId = res.data.priceGroupQueueId;

                        // set options to primary values
                        this.setDateUngrandfather = null;
                        this.ungrandfatherOption = MembershipTypeUngrandfatherEnum.BenefitTemplate;
                    });

                    this.loadingInProgress = false;
                }
            });
        }

        // Remove ungradfathering
        removeScheduledUngrandfathering(): void {
            let criteria = {
                ungrandfathering: true,
                membershipTypeId: this.model.id
            };

            this.loadingInProgress = true;
            
            this.dataService.customMethodData(`/api/MarketPricing/${this.priceGroupQueueId}/Ungrandfather`, 'DELETE', criteria).then(() => {
                this.isUngrandfatherNotAllow = false;
                this.isUngrandfatherExist = false;

                this.scheduledUngrandfathering = {
                    type: null,
                    date: null,
                    label: ''
                }

                this.loadingInProgress = false;
            });
        }
    }
}